/**
 * @file: This file marks one row of a sortable list.
 *
 * A sortable row needs the two attributes the drag handler reads, and the two
 * classes that show the drag. Three templates wrote the same recipe, and one of
 * them wrote it differently.
 *
 * The attribute takes the drop target of its list, and the id and the index of
 * the row:
 *
 *   <li drag-drop-row="ctrl.itemDrop" drag-drop-row-id="item.id"
 *       drag-drop-row-index="$index">
 *
 * The end of the list is not a row, so the class for it is on the container.
 * See `dragDropList`.
 */

import angular from 'angular'

const BEFORE = 'drag-drop-before'
const DRAGGING = 'drag-drop-dragging'

function dragDropRow () {
  'ngInject'

  return {
    restrict: 'A',
    link ($scope, $element, attrs) {
      const element = $element[0]

      function draw (target, id, index) {
        element.setAttribute('data-drag-id', id === undefined || id === null ? '' : String(id))
        element.setAttribute('data-drag-index', String(index))
        element.classList.toggle(BEFORE, Boolean(target) && target.index === index)
        element.classList.toggle(DRAGGING, Boolean(target) && target.from === index)
      }

      $scope.$watchGroup(
        [attrs.dragDropRow, attrs.dragDropRowId, attrs.dragDropRowIndex],
        ([target, id, index]) => draw(target, id, index)
      )
    }
  }
}

/**
 * The container of a sortable list. It has one class while the dragged row
 * would land after the last row, because that boundary has no row of its own.
 *
 *   <ul drag-drop-list="ctrl.itemDrop" drag-drop-list-count="ctrl.items.length">
 */
function dragDropList () {
  'ngInject'

  return {
    restrict: 'A',
    link ($scope, $element, attrs) {
      const element = $element[0]

      $scope.$watchGroup([attrs.dragDropList, attrs.dragDropListCount], ([target, count]) => {
        element.classList.toggle('drag-drop-at-end', Boolean(target) && target.index === count)
      })
    }
  }
}

export default angular.module('drag-drop-row.directive', [])
  .directive('dragDropRow', dragDropRow)
  .directive('dragDropList', dragDropList)
  .name

export { dragDropRow, dragDropList }
